module.exports = __webpack_public_path__ + "static/b1-c86e89637b27989f512198b2d285df91.jpg";